import React from "react";
import { ArrowDown, MapPin, Calendar } from "lucide-react";
import Snow from "./Snow";
import { HERO_IMAGE } from "../mock";

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 animate-slow-zoom"
        style={{
          backgroundImage: `url(${HERO_IMAGE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0c1a14]/70 via-[#0c1a14]/45 to-[#0c1a14]/85" />
      {/* Snow */}
      <Snow count={45} />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 min-h-screen flex flex-col justify-center items-center text-center pt-24 pb-16">
        <div className="flex items-center gap-3 mb-6 text-[#e9c987]">
          <span className="h-px w-10 bg-[#e9c987]" />
          <span className="text-[11px] tracking-[0.42em] uppercase font-medium">
            December 3 – 13, 2026
          </span>
          <span className="h-px w-10 bg-[#e9c987]" />
        </div>

        <h1 className="font-display text-[#faf5ec] text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.02] max-w-5xl">
          Experience the Magic of
          <br />
          <span className="font-script text-[#e9c987] text-6xl sm:text-7xl md:text-8xl lg:text-[120px] block leading-[1.1] mt-3">
            Europe&rsquo;s Christmas
          </span>
          <span className="font-display italic text-[#faf5ec]">Markets</span>
        </h1>

        <p className="mt-8 max-w-2xl text-[#faf5ec]/85 text-lg leading-relaxed font-light">
          A 10-day ladies&rsquo; getaway through London, Brussels, Bruges, Paris and
          Strasbourg — hand-crafted for shared memories that sparkle long after
          the season ends.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a href="#itinerary" className="btn-primary">View Itinerary</a>
          <a href="#reserve" className="btn-outline">Reserve Your Spot</a>
          <a href="#pricing" className="btn-outline">Pricing &amp; Details</a>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-[#faf5ec]/80 text-sm">
          <span className="inline-flex items-center gap-2">
            <Calendar className="w-4 h-4 text-[#e9c987]" strokeWidth={1.5} />
            10 Days / 9 Nights
          </span>
          <span className="inline-flex items-center gap-2">
            <MapPin className="w-4 h-4 text-[#e9c987]" strokeWidth={1.5} />
            UK · Belgium · France
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#e9c987]" />
            Ladies-only, small group
          </span>
        </div>
      </div>

      <a
        href="#overview"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#faf5ec]/70 hover:text-[#e9c987] transition-colors flex flex-col items-center gap-2"
      >
        <span className="text-[10px] tracking-[0.32em] uppercase">Scroll</span>
        <ArrowDown className="w-4 h-4 animate-bounce" strokeWidth={1.5} />
      </a>
    </section>
  );
};

export default Hero;
